// extracted by mini-css-extract-plugin
export default {"clickableSection":"ClickableSection_clickableSection__oSBXy","content":"ClickableSection_content__NOxGd","text":"ClickableSection_text__UeoIx","icon":"ClickableSection_icon__9QNga"};